import { child, get, getDatabase, ref } from "firebase/database"
import moment from "moment"
import { useEffect, useMemo, useState } from "react"
import { useParams } from "react-router-dom"
import FirebaseWriter from "../../Firebase/FirebaseWriter"
import { thoughtIsReply } from "../../Firebase/ReplyUtilities"
import {
  ConnectionKind,
  ConnectionMap,
  EdgeInfo,
  PostMap,
  TextPost,
} from "../../ReactContexts/PostContext"
import { backendWriter } from "../App"

const ConnectionAdminStats = () => {
  const { placeId } = useParams()
  const [allThoughts, setAllThoughts] = useState([])
  const [posts, setPosts] = useState<PostMap>()
  const [loadingThoughts, setLoadingThoughts] = useState("loading...")
  const [loadingPeople, setLoadingPeople] = useState("loading people...")

  useEffect(() => {
    const db = getDatabase()
    const domainRef = ref(db, "p/" + (placeId ?? "forum")) //nodes are posts

    const postsRef = child(domainRef, "nodes") //nodes are posts
    get(postsRef).then((snapshot) => {
      if (snapshot.exists()) {
        const value = snapshot.val()
        setPosts(value)
        setAllThoughts(Object.values(value).reverse())
        setLoadingThoughts("loaded!")
      }
    })

    const peopleRef = child(domainRef, "people") //nodes are posts
    get(peopleRef).then((snapshot) => {
      if (snapshot.exists()) {
        setLoadingPeople("loaded people!")
      }
    })
  }, [placeId])

  const allConnections = useMemo(() => {
    return getAllPosConnectionsFromThoughtArr(allThoughts)
  }, [allThoughts])

  /**
   *    //for all the posts in the entire network, find suggestions for them
   * @param posts
   */
  const migrateSuggestions = (posts: PostMap) => {
    const db = getDatabase()
    const domainRef = ref(db, "p/forum") //nodes are posts
    backendWriter.initialize(domainRef, "plexus-default", "app@plexus.earth", "plexus team")
    const postArr = Object.values(posts ?? {})
    const unfound = postArr.filter(
      //first just for my thoughts

      (e) => !thoughtIsReply(e) && e.timestamp && !FirebaseWriter.checkIfThoughtAlreadyHasSugg(e)
    )
    unfound.forEach((post, i) => {
      //buffer in between api calls
      // sleep(10)

      backendWriter.findAndRecordSuggestionsForThought(post, placeId)
    })
  }

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <button
        style={{ width: "fit-content", margin: "1em" }}
        onClick={() => migrateSuggestions(posts)}
      >
        find and store suggestions for past thoughts (inactive)
      </button>

      <div>{loadingThoughts}</div>
      <div>{loadingPeople}</div>
      <hr></hr>
      <h3> {allConnections?.length} CONNECTION Connections </h3>
      {allConnections.map((e) => (
        <div>
          <div>{moment(e.timestamp).fromNow()}</div>
          <div>authorId: {e.authorId}</div>
          <div>sourceThoughtId: {e.sourceId}</div>
          <div>type: {e.edgeKind}</div>

          <hr></hr>
        </div>
      ))}
      <hr></hr>
    </div>
  )
}

export default ConnectionAdminStats

const getAllPosConnectionsFromThoughtArr = (thoughtArr: TextPost[]): EdgeInfo[] => {
  let connections: EdgeInfo[] = []
  thoughtArr.forEach((thought: TextPost) => {
    Object.entries(thought.connections?.inbound ?? {}).forEach(
      ([otherThoughtId, map]: [string, ConnectionMap]) => {
        //each of these connections, add it
        const edges = Object.values(map)
        const posConnectEdges = edges.filter(
          (e) => e.edgeKind === ConnectionKind.CONNECTION && !("anti" in e)
        )
        if (posConnectEdges.length > 0) {
          connections.push(posConnectEdges[0])
        }
      }
    )
  })
  const sorted = connections.sort((a, b) => b.timestamp - a.timestamp)

  //filtered by time window

  return sorted
}

/**
 * Function for getting all the connections in the network, given an array of all the thoughts
 * @param allThoughts
 * @param startTime //@Micah for you to fill these in, I figured it could be an number represending seconds since epoch, but figured you might prefer a different format, too.
 * @param endTime //@Micah for you to fill these in, I figured it could be an number represending seconds since epoch, but figured you might prefer a different format, too.
 * @returns
 */
export const getAllConnectionsInTimeWindow = (
  allThoughts: TextPost[],
  startTime: number,
  endTime: number
) => {
  const allConnections = getAllPosConnectionsFromThoughtArr(allThoughts)
  const windowedConnections = filterConnectionsByTimeWindow(allConnections, startTime, endTime)
  return windowedConnections
}

/**
 * @param edges
 * @param startTime
 * @param endTime
 * @returns
 */
export function filterConnectionsByTimeWindow(
  edges: EdgeInfo[],
  startTime: number,
  endTime: number
): EdgeInfo[] {
  return edges.filter((edge) => {
    //check whether timestamp is in desired window.
    return edge.timestamp < endTime && edge.timestamp > startTime
  })
}
